import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Record } from 'src/app/core/models/record.model';

@Component({
  selector: 'app-dialog-record',
  templateUrl: './dialog-record.component.html',
  styleUrls: ['./dialog-record.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogRecordComponent implements OnInit {

  input = new FormControl(this.data?.record[this.data?.key]);

  constructor(
    private dialogRef: MatDialogRef<DialogRecordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { record: Record, key: string }
  ) { }

  ngOnInit(): void {
  }

  save() {
    this.dialogRef.close({
      ...this.data.record,
      [this.data.key]: this.input.value
    });
  }

}
